define('ROOM4.CCAGalleryShowcase.Showcase.View', [
    'Backbone.CollectionView',
    'ROOM4.CCAGalleryShowcase.Showcase.Collection',
    'ROOM4.CCAGalleryShowcase.ShowcaseItem.View',
    'room4_ccagalleryshowcase_showcase.tpl',
    'room4_ccagalleryshowcase_row.tpl',
    'room4_ccagalleryshowcase_cell.tpl',
    'Configuration',
    'Utils',
    'jQuery'
], function(
    BackboneCollectionView,
    ShowcaseCollection,
    ShowcaseItemView,
    room4_ccagalleryshowcase_showcase_tpl,
    room4_ccagalleryshowcase_row_tpl,
    room4_ccagalleryshowcase_cell_tpl,
    Configuration,
    Utils,
    jQuery
) {
    'use strict';

    return BackboneCollectionView.extend({
        initialize: function initialize(options) {
            options = options || {};

            this.application = options.application || options.container;
            this.title = options.title || 'See It On Real Vehicles';
            this.itemId = options.itemId;
            this.limit = options.limit || 6;
            this.view_tracked = false;

            this.collection = new ShowcaseCollection([], {
                itemId: this.itemId,
                limit: this.limit
            });

            BackboneCollectionView.prototype.initialize.call(this, {
                collection: this.collection,
                viewsPerRow: Infinity,
                cellTemplate: room4_ccagalleryshowcase_cell_tpl,
                rowTemplate: room4_ccagalleryshowcase_row_tpl,
                childView: ShowcaseItemView,
                template: room4_ccagalleryshowcase_showcase_tpl
            });

            this.loadCases();
        },

        loadCases: function loadCases() {
            var self = this;

            if (!this.itemId) {
                this.render();
                return;
            }

            this.collection.fetchCases().then(function fetchCasesDone() {
                self.render();
            }, function fetchCasesFailed() {
                self.collection.reset([]);
                self.render();
            });
        },

        render: function render() {
            BackboneCollectionView.prototype.render.call(this);

            // a single case renders as a static centered card; the slider
            // would only add clones and a one-dot pager
            if (this.collection.length > 1) {
                this.queueCarouselInitialize();
            }

            return this;
        },

        // same deferred-init flow as core ItemRelations.Related.View: init
        // immediately when already in the DOM, otherwise on the layout's
        // next afterAppendView
        queueCarouselInitialize: function queueCarouselInitialize() {
            var layout = this.application && this.application.getLayout && this.application.getLayout();

            if (!jQuery.contains(document.documentElement, this.$el[0]) && layout && layout.once) {
                layout.once('afterAppendView', this.carouselInitialize, this);
            } else {
                this.carouselInitialize();
            }
        },

        carouselInitialize: function carouselInitialize() {
            var carousel = this.$el.find('[data-type="carousel-items"]');

            // parent .bx-viewport means this DOM is already a live slider —
            // initializing twice nests wrappers and breaks widths
            if (carousel.length > 0 && !carousel.parent().hasClass('bx-viewport')) {
                Utils.initBxSlider(carousel, Configuration.get('bxSliderDefaults', {}));
                this.suppressClickAfterDrag(carousel);
            }
        },

        // Card links/images are draggable="false" so bxSlider can be dragged
        // by the mouse from anywhere on a slide. bxSlider itself never cancels
        // the click that fires after a mouse drag ends on a link, so without
        // this guard finishing a swipe on a card would navigate to it.
        suppressClickAfterDrag: function suppressClickAfterDrag(carousel) {
            var start = null;
            // matches bxSlider's default swipeThreshold
            var threshold = 10;

            carousel.on('pointerdown touchstart', function onPointerDown(e) {
                var point = e.originalEvent.changedTouches
                    ? e.originalEvent.changedTouches[0]
                    : e.originalEvent;
                start = { x: point.pageX, y: point.pageY };
            });

            carousel.on('click', 'a', function onCardClick(e) {
                if (!start) {
                    return;
                }
                var moved = Math.max(
                    Math.abs(e.pageX - start.x),
                    Math.abs(e.pageY - start.y)
                );
                if (moved >= threshold) {
                    // preventDefault alone is not enough: SuiteCommerce's
                    // document-level touchpoint handler navigates regardless,
                    // so the click must not bubble out of the carousel
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            });
        },

        getContext: function getContext() {
            return {
                showCells: this.collection.length > 0,
                title: this.title,
                // numberOfItems describes what is actually rendered, not the
                // backend total
                numberOfItems: this.collection.length,
                totalRecordsFound: this.collection.totalRecordsFound || 0
            };
        }
    });
});
